(function () {
  'use strict';

  angular.module('app').component('tourContentDetail', tourContentDetail());

  function tourContentDetail() {
    return {
      bindings: {
        item: '=',
        tourId: '<',
        onTourContentSaved: '&',
        onTourContentCanceled: '&',
        websiteId: '<',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: TourContentDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/tour-contents/tour-content-detail/tour-content-detail.component.html',
    };
  }

  TourContentDetailComponent.$inject = [
    'UtilService',
    'SessionService',
    'TourContentService',
    'TourService',
    'TagService',

    // Angular downgraded service
    'ng2Router',
  ];

  function TourContentDetailComponent(
    UtilService,
    SessionService,
    TourContentService,
    TourService,
    TagService,

    // Angular downgraded service
    ng2Router
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);
    var cropedImage = { file: null };

    // Methods
    vm.tagTransform = tagTransform;
    vm.checkTagOptions = checkTagOptions;

    vm.selectParentTour = selectParentTour;
    vm.updateSeoTitle = updateSeoTitle;
    vm.setSeoTitle = setSeoTitle;
    vm.updateSeoDescription = updateSeoDescription;
    vm.setSeoDescription = setSeoDescription;
    vm.nameChanged = false;

    vm.cancelEdit = cancelEdit;
    vm.saveTourContent = saveTourContent;
    vm.cancel = cancel;
    vm.openTourContentTranslation = openTourContentTranslation;
    vm.openLogo = openLogo;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        vm.editMode = true;

        vm.flashMessage = vm.UtilService._displayFlashMessage();

        vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(vm.item.url_video);

        vm.itemName = vm.item.name;
        vm.labelAddLogo = vm.item.logo.url ? 'CHANGE_PHOTO' : 'ADD_PHOTO';
        vm.originalItem = angular.copy(vm.item);
      } else {
        // New
        if (vm.tourId) {
          vm.item.tour_id = vm.tourId; // optional from modal
        }

        vm.item.website_id = vm.websiteId;
        vm.isUrlRequiredisUrlValid = false;
        vm.item.url = '';

        vm.item.published = false;

        vm.labelAddLogo = 'ADD_PHOTO';
      }

      var companyWebsites = SessionService.getSelectedAccountCompany().websites;

      vm.websiteName = vm.UtilService.findItemInArray(companyWebsites, 'id', vm.websiteId).name;
      vm.tabs = vm.UtilService.websiteTabs(vm.websiteId);

      // Initializers
      getToursContents();
      getTags(vm.defaultLanguage);
    };

    function cancelEdit() {
      vm.cancel();
    }

    function getTours(tourIds) {
      TourService.getTours({ get: 'selector', skip_check_role: true }).then(function (data) {
        vm.tours = [];

        data.items.forEach(function (tour) {
          for (var i = 0; i < tourIds.length; i++) {
            var tourId = tourIds[i];
            if (tour.id === tourId) {
              if (vm.item.tour_id === tourId) {
                tour.current = true;
              } else {
                tour.inUse = true;
              }

              break;
            }
          }

          vm.tours.push(tour);
        });
      });
    }

    function getToursContents() {
      var filterCriteria = {
        get: 'active',
        skip_check_role: true,
      };

      TourContentService.getToursContents(vm.item.website_id, filterCriteria).then(function (data) {
        var tourIds = [];

        data.items.forEach(function (content) {
          tourIds.push(content.tour_id);
        });

        getTours(tourIds);
      });
    }

    function selectParentTour(tour) {
      if (!vm.item.id) {
        // Create mode
        vm.item.name = tour.name;
        updateSeoTitle();
      }
    }

    // ----- SEO ----- //
    function updateSeoTitle() {
      if (!vm.item.seo_title_filled) {
        vm.item.seo_title = vm.item.name;
      }
    }

    function setSeoTitle() {
      vm.item.seo_title_filled = vm.item.seo_title ? true : false;
    }

    function updateSeoDescription() {
      if (!vm.item.seo_description_filled) {
        vm.item.seo_description = vm.item.description.replace(/<\/?[^>]+(>|$)/g, ''); // text only
      }
    }

    function setSeoDescription() {
      vm.item.seo_description_filled = vm.item.seo_description ? true : false;
    }

    function openLogo() {
      let logoSaved = (cropedImageObj) => {
        cropedImage = cropedImageObj;

        if (vm.editMode) {
          TourContentService.updateLogo(vm.item, cropedImage);
        } else {
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>
          img.src = URL.createObjectURL(cropedImage.file);
        }
      };

      TourContentService.openLogo(vm.item, logoSaved);
    }

    // ----- TAGS -----

    function getTags(lang) {
      TagService.getTags({ skip_check_role: true, by_lang: lang }).then(function (data) {
        vm.tags = data.items;
      });
    }

    function tagTransform(name) {
      return TagService.tagTransform(name, vm.defaultLanguage);
    }

    function checkTagOptions(tag) {
      vm.tagOptions = TagService.checkTagOptions(tag, vm.tags);
    }

    // Create / udpate tour content
    function saveTourContent(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid || vm.item.url === '') {
        vm.isUrlRequired = true;
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      var successCallback = function () {
        vm.sendingForm = true;
        TourContentService.saveTourContent(vm.item, vm.defaultLanguage, cropedImage).then(
          function (res) {
            let response = res.data;

            vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(response.url_video);

            if (!vm.editMode) {
              // Create
              vm.onTourContentSaved({ item: response });
            } else {
              // Edit
              vm.flashMessage = vm.UtilService._clearFlashMessage();

              vm.itemName = response.name;
              vm.originalItem = angular.copy(vm.item);
            }

            vm.sendingForm = false;

            vm.UtilService.scrollToTop();
          },
          function (response) {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.data.errors);

            if (response.data.error) {
              vm.serverErrors.publish = response.data.error;
            }

            vm.formErrors = true;
            vm.UtilService.scrollToTop();

            vm.sendingForm = false;
          }
        );
      };

      const callback = (response) => {
        if (response === 'edit') {
          vm.UtilService.scrollToTop();

          return;
        }

        if (response === 'generate') {
          vm.item.url = UtilService.prototype.generateURL(vm.item);
        }

        successCallback();
      };

      if (vm.item.id && vm.item.name !== vm.originalItem.name) {
        vm.UtilService.openProductsChangeUrlModal(callback);
      } else {
        successCallback();
      }
    }

    function cancel() {
      vm.onTourContentCanceled({ item: vm.item });
    }

    function openTourContentTranslation() {
      TourContentService.openTourContentTranslation(
        vm.item.id,
        vm.websiteName,
        vm.additionalLanguages
      );
    }

    vm.goToWebsiteDetail = (websiteId) => {
      ng2Router.navigate(['/ng/websites', websiteId]);
    };

    // function isUrlValid() {
    //   if (vm.item.url === '') vm.isUrlRequired = true;
    //   return;
    // }
  }
})();
